import { render } from "./Toolbar.vue?vue&type=template&id=673d08f3&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=673d08f3&scoped=true&lang=scss"

import exportComponent from "/double-take/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673d08f3"]])

export default __exports__